import RestService from "./restService";
import { NOTES } from "../../url/index";

const singleton = Symbol();
const singletonEnforcer = Symbol();

/**
 *
 */
class NoteService extends RestService {
  constructor(enforcer) {
    super(NOTES);
    if (enforcer !== singletonEnforcer) throw new Error("Cannot construct Note RestService more than one");
  }

  static get instance() {
    if (!this[singleton]) {
      this[singleton] = new NoteService(singletonEnforcer);
    }
    return this[singleton];
  }
}

export default NoteService;
